function fullname(name) {
  let items = []
  if (name?.last) items.push(name?.last)
  if (name?.first) items.push(name?.first)
  return items.join(', ')
}

export default fullname